import PropTypes from 'prop-types'

import AtomButton, {atomButtonColors, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import FormBuilder from '@s-ui/react-form-builder'

import useFormPlate from './useFormPlate.js'

const FormPlate = ({onGetVehicles, sellerVehicle}) => {
  const {
    formConfiguration,
    handleOnBlur,
    handleOnChange,
    handleOnSubmit,
    initialValues,
    isLoading,
    validatedErrors,
    setValidatedErrors,
    SUIComponentsConfig
  } = useFormPlate({onGetVehicles, sellerVehicle})

  return (
    <>
      <FormBuilder
        errors={validatedErrors}
        initFields={initialValues}
        json={formConfiguration}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        setErrors={setValidatedErrors}
      >
        {SUIComponentsConfig}
      </FormBuilder>
      <AtomButton
        color={atomButtonColors.ACCENT}
        isLoading={isLoading}
        fullWidth
        onClick={handleOnSubmit}
        shape={atomButtonShapes.CIRCULAR}
        size={atomButtonSizes.LARGE}
      >
        {`Obtener tasación`}
      </AtomButton>
    </>
  )
}

FormPlate.displayName = 'FormPlate'

FormPlate.propTypes = {
  onGetVehicles: PropTypes.func.isRequired,
  sellerVehicle: PropTypes.shape({km: PropTypes.string.isRequired, plate: PropTypes.string.isRequired}).isRequired
}

export default FormPlate
